<template>
  <v-card flat>
    <b-row>
      <b-col :md="6">
        <b-form-group
          id="name-group"
          v-bind:label="$t('FORM_LABELS.NAME')"
          label-for="name-input"
        >
          <FormInput
            id="name-input"
            v-model="form.name"
            type="text"
            name="name"
            :i18n="{
              label: 'FORM_LABELS.NAME',
              placeholder: $t('FORM_LABELS.NAME')
            }"
            :validateState="validateState('name')"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="address-group"
          v-bind:label="$t('FORM_LABELS.ADDRESS')"
          label-for="address-input"
        >
          <FormInput
            id="address-input"
            v-model="form.address"
            type="text"
            name="address"
            :i18n="{
              label: 'FORM_LABELS.ADDRESS',
              placeholder: $t('FORM_LABELS.ADDRESS')
            }"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="phone-group"
          v-bind:label="$t('FORM_LABELS.PHONE')"
          label-for="phone-input"
        >
          <FormInput
            id="phone-input"
            v-model="form.phone"
            type="number"
            name="phone"
            :i18n="{
              label: 'FORM_LABELS.PHONE',
              placeholder: $t('FORM_LABELS.PHONE')
            }"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="bulstat-group"
          v-bind:label="$t('FORM_LABELS.BULSTAT')"
          label-for="bulstat-input"
        >
          <FormInput
            id="bulstat-input"
            v-model="form.bulstat"
            type="text"
            name="bulstat"
            :i18n="{
              label: 'FORM_LABELS.BULSTAT',
              placeholder: $t('FORM_LABELS.BULSTAT')
            }"
          ></FormInput>
        </b-form-group>
      </b-col>
    </b-row>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapState } from "vuex";
import { formBuilderMixin } from "@/core/mixins/formBuilderMixin.js";

import FormInput from "@/view/content/forms/components/FormInput.vue";

export default {
  mixins: [validationMixin, formBuilderMixin],
  components: {
    FormInput
  },
  props: {
    form: Object
  },
  data() {
    return {
      errors: {}
    };
  },
  validations() {
    const tmpValidationObject = {
      form: {
        name: this.setItemValidations({
          required: true
        })
      }
    };

    return tmpValidationObject;
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    }
  }
};
</script>
